import React from 'react';
import { confirmSteps } from '../../data/confirmSteps';
export function ConfirmSteps() {
  return <section className="mx-auto mt-12 max-w-2xl px-6" aria-labelledby="confirm-heading" data-id="element-63" data-mp="djpuhr99gu5a">
      <h2 id="confirm-heading" className="text-center font-display text-3xl text-ink" data-id="element-64" data-mp="3us328lhk17x5">
        How to <em className="text-gold" data-id="element-65" data-mp="3l0btw9jj5nz">confirm</em> your tour
      </h2>
      <p className="mt-2 text-center font-body text-sm text-ink/60" data-id="element-66" data-mp="3nd0stdpugaj">
        Three quick steps — it takes about a minute.
      </p>
      <ol className="mt-8 border-b border-ink/10" data-id="element-67" data-mp="3qppzm5y3tq4l">
        {confirmSteps.map((step, i) => <li key={step.title} className="flex gap-5 border-t border-ink/10 py-6" data-id="element-68" data-mp="3c1bvlroybvmg" data-mpi={i}>
            <span className="w-4 shrink-0 font-display text-xl text-gold" data-id="element-69" data-mp="3bz8zqr14b89t">{i + 1}</span>
            <div data-id="element-70" data-mp="3gy2dmkkbh1ai">
              <h3 className="font-body text-[17px] font-medium text-ink" data-id="element-71" data-mp="330doh0j7v7zn">{step.title}</h3>
              <p className="mt-1.5 font-body text-[15px] leading-relaxed text-ink/70" data-id="element-72" data-mp="332rmni9710bf">
                {step.body}{' '}
                {step.highlight && <span className="font-medium text-gold" data-id="element-73" data-mp="3f51vn38qts9p">{step.highlight}</span>}
              </p>
            </div>
          </li>)}
      </ol>
    </section>;
}